import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { withRouter, matchPath } from "react-router-dom";
import { Select, Input, Radio, Row, Col, Button, Card, Typography, Spin, notification } from "antd";
import { DatePicker } from "antd";
import Dropzone from "react-dropzone";
import moment from "moment";
import { controller } from "../../controller";
import config from "../../config";
import DashboardLayout from "../../layout/dashboardLayout/DashboardLayout.js";
import { Error } from "../../ErrorHandeling";
import "../addProvider/style.css";
import calendar from "../../assets/icons/calendar.png";
import arrow from "../../assets/icons/arrow-left.png";
import routes from "../../constants/routes.json";

const { Title } = Typography;

/** Resolves provider id from route. Hash routes live in window.location.hash while BrowserRouter can leave pathname as "/". */
function getProviderIdFromRoute(props) {
  const { match, location } = props;
  if (match && match.params && match.params.id != null && match.params.id !== "") {
    return String(match.params.id);
  }
  const pathname = (location && location.pathname) || "";
  let pathToMatch = pathname;
  if (typeof window !== "undefined" && window.location.hash && window.location.hash.length > 1) {
    pathToMatch = window.location.hash.replace(/^#/, "").split("?")[0] || pathname;
  }
  const m = matchPath(pathToMatch, { path: routes.EDIT_PROVIDER, exact: true });
  if (m && m.params && m.params.id != null) {
    return String(m.params.id);
  }
  const parts = pathToMatch.split("/").filter(Boolean);
  const i = parts.indexOf("providers");
  if (i >= 0 && parts[i + 1] && parts[i + 2] === "edit") {
    return parts[i + 1];
  }
  return null;
}

/**
 * HTTP status from controller helpers. We use `_httpStatus` so the Provider model field `status`
 * (Active/Inactive) is never confused with the HTTP code. Falls back to numeric `status` only
 * when it looks like an HTTP status (100–599) for older responses.
 */
function httpStatusFromControllerResponse(obj) {
  if (!obj || typeof obj !== "object") return undefined;
  if (typeof obj._httpStatus === "number") return obj._httpStatus;
  if (typeof obj.status === "number" && obj.status >= 100 && obj.status < 600) return obj.status;
  return undefined;
}

const { Option } = Select;

const fieldOk = { massage: "", status: true };

async function optionalEmail(v) {
  const s = (v || "").trim();
  if (!s) return fieldOk;
  return Error.EmailHandling(s);
}

async function optionalPhone(v) {
  const s = (v || "").replace(/ /g, "");
  if (!s) return fieldOk;
  return Error.PhoneHandling(s);
}

async function optionalAddressField(v) {
  const s = (v || "").trim();
  if (!s) return fieldOk;
  return Error.NameHandling(s);
}

async function optionalBirthdate(v) {
  const s = (v || "").trim();
  if (!s) return fieldOk;
  return Error.BirthDateHandling(s);
}

function validateProviderStatus(v) {
  if (v === "Active" || v === "Inactive") return fieldOk;
  return { massage: "Status is required", status: false };
}

async function optionalImageUpload(file) {
  if (!file) return fieldOk;
  return Error.UploadFileIMG(file);
}

async function syncAppointmentTypesForProvider(providerId, selectedTypeIds) {
  const res = await controller.getListOfAppointmentTypes(0);
  const raw = res.json;
  const types = Array.isArray(raw) ? raw : raw && raw.results ? raw.results : [];
  for (const aptType of types) {
    const providerIds = (aptType.provider || []).map((p) => p.id);
    const shouldInclude = selectedTypeIds.includes(aptType.id);
    const currentlyIncludes = providerIds.includes(providerId);
    if (shouldInclude === currentlyIncludes) continue;
    const newIds = shouldInclude ? [...new Set([...providerIds, providerId])] : providerIds.filter((pid) => pid !== providerId);
    await controller.EditAppointmentType({ id: aptType.id, provider: newIds });
  }
}

class EditProvider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      serverLogo: "",
      loading: true,
      loadError: null,
      patient_birth_Date: null,
      provider_fullname: "",
      provider_phone: "",
      provider_email: "",
      provider_specialty: "",
      provider_status: "",
      providerImage: null,
      existingImagePath: "",
      address_line1: "",
      birthdate: "",
      city: "",
      license_number: "",
      unique_provider_number: "",
      appt_types: [],
      appt_types_id: [],
      office_services: [],
      operatories: [],
      sending_data: false,
      formError: {
        address_line1: { massage: "", status: true },
        birthdate: { massage: "", status: true },
        city: { massage: "", status: true },
        FullName: { massage: "", status: true },
        Email: { massage: "", status: true },
        Type: { massage: "", status: true },
        Specialty: { massage: "", status: true },
        Image: { massage: "", status: true },
        Phone: { massage: "", status: true },
        license_number: { massage: "", status: true },
        unique_provider_number: { massage: "", status: true },
        Status: { massage: "", status: true },
      },
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleBirthDateChange = this.handleBirthDateChange.bind(this);
  }

  async componentDidMount() {
    const logo = await controller.getLogo();
    this.setState({ serverLogo: logo.data && logo.data.dark ? logo.data.dark : "" });
    await this.get_officeservices();
    await this.loadProvider();
  }

  componentDidUpdate(prevProps) {
    const prevId = getProviderIdFromRoute(prevProps);
    const nextId = getProviderIdFromRoute(this.props);
    if (nextId && nextId !== prevId && this.state.loadError) {
      this.loadProvider();
    }
  }

  get_officeservices = async () => {
    const response = await controller.office_services(localStorage.getItem("selectedOffice"));
    this.setState({ office_services: Object.values(response) });
  };

  loadProvider = async () => {
    const id = getProviderIdFromRoute(this.props);
    if (!id) {
      this.setState({ loading: false, loadError: "Could not load provider" });
      return;
    }
    this.setState({ loading: true, loadError: null });
    try {
      const data = await controller.getProviderForUpdate(id);
      const httpStatus = httpStatusFromControllerResponse(data);
      if (httpStatus != null && httpStatus >= 400) {
        this.setState({
          loading: false,
          loadError: (data.detail && String(data.detail)) || "Could not load provider",
        });
        return;
      }
      const m = data.birthdate
        ? moment(data.birthdate, ["YYYY-MM-DD", "MM/DD/YYYY", "MM-DD-YYYY"], true).isValid()
          ? moment(data.birthdate, ["YYYY-MM-DD", "MM/DD/YYYY", "MM-DD-YYYY"], true)
          : moment(data.birthdate)
        : null;
      const birthStr = m && m.isValid() ? m.format("MM-DD-YYYY") : data.birthdate || "";

      let phoneDisplay = data.phone || "";
      if (phoneDisplay && phoneDisplay.length === 10 && !/\s/.test(phoneDisplay)) {
        phoneDisplay = phoneDisplay.slice(0, 3) + " " + phoneDisplay.slice(3, 6) + " " + phoneDisplay.slice(6);
      }

      const normStatus = (s) => {
        if (s == null || s === "") return "Active";
        const t = String(s).toLowerCase();
        if (t === "active") return "Active";
        if (t === "inactive") return "Inactive";
        return s;
      };

      const spec = data.specialty || "";
      const specialtyDisplay = spec === "unknown" ? "" : spec;

      const aptRes = await controller.getListOfAppointmentTypes(0);
      const rawTypes = aptRes.json;
      const allTypes = Array.isArray(rawTypes) ? rawTypes : rawTypes && rawTypes.results ? rawTypes.results : [];
      const pid = data.id;
      const appt_types = [];
      const appt_types_id = [];
      for (const t of allTypes) {
        const ids = (t.provider || []).map((p) => p.id);
        if (ids.includes(pid)) {
          appt_types.push(t.service);
          appt_types_id.push(t.id);
        }
      }

      this.setState({
        loading: false,
        provider_fullname: data.name || "",
        provider_phone: phoneDisplay,
        provider_email: data.email || "",
        provider_specialty: specialtyDisplay,
        provider_status: normStatus(data.status),
        address_line1: data.address_line1 || "",
        city: data.city || "",
        birthdate: birthStr,
        patient_birth_Date: m && m.isValid() ? m : null,
        existingImagePath: data.image || "",
        license_number: data.license_number != null ? data.license_number : "",
        unique_provider_number: data.unique_provider_number != null ? data.unique_provider_number : "",
        appt_types,
        appt_types_id,
      });
    } catch (e) {
      this.setState({ loading: false, loadError: "Could not load provider" });
    }
  };

  openNotification = (placement, message, status) => {
    if (status && status.toLowerCase().search("success") !== -1) {
      notification.success({ message: status, description: message, placement });
    } else if (status && status.toLowerCase().search("error") !== -1) {
      notification.error({ message: status, description: message, placement });
    } else {
      notification.info({ message: status, description: message, placement });
    }
  };

  handleBirthDateChange(value, dateString) {
    this.setState({
      patient_birth_Date: value,
      birthdate: dateString,
    });
  }

  handleChange(e) {
    let { name, value } = e.target;
    if (name === "provider_phone") {
      value = value.replace(/ /g, "");
      if (value.length < 10) {
        if (value.length === 8) {
          value = value.replace(/ /g, "");
          this.setState({
            provider_phone: value.slice(0, 3) + " " + value.slice(3, 6) + " " + value.slice(6),
          });
        } else {
          value = value.replace(/[^\dA-Z]/g, "").replace(/(.{3})/g, "$1 ").trim();
          this.setState({ [name]: value });
        }
      }
      if (value.length === 10) {
        value = value.slice(0, 3) + " " + value.slice(3, 6) + " " + value.slice(6);
        this.setState({ [name]: value });
      }
    } else {
      this.setState({ [name]: value });
    }
  }

  handleChangeAppointmentType = (selectedServices) => {
    const ids = [];
    const services = this.state.office_services || [];
    for (const svc of services) {
      if (selectedServices.includes(svc.service)) ids.push(svc.id);
    }
    this.setState({ appt_types: selectedServices, appt_types_id: ids });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const id = getProviderIdFromRoute(this.props);
    if (!id) {
      this.openNotification("bottom", "Missing provider id in URL.", "Error");
      return;
    }

    const FullName_validation = await Error.NameHandling(this.state.provider_fullname);
    const Status_validation = validateProviderStatus(this.state.provider_status);
    const Email_validation = await optionalEmail(this.state.provider_email);
    const Phone_validation = await optionalPhone(this.state.provider_phone);
    const Type_validation = fieldOk;
    const specialty_validation = fieldOk;
    const Image_validation = this.state.existingImagePath
      ? fieldOk
      : await optionalImageUpload(this.state.providerImage);
    const address_validation = await optionalAddressField(this.state.address_line1);
    const birthdate_validation = await optionalBirthdate(this.state.birthdate);
    const city_validation = await optionalAddressField(this.state.city);

    this.setState({
      formError: {
        ...this.state.formError,
        FullName: FullName_validation,
        Status: Status_validation,
        Email: Email_validation,
        Type: Type_validation,
        Specialty: specialty_validation,
        Image: Image_validation,
        Phone: Phone_validation,
        city: city_validation,
        birthdate: birthdate_validation,
        address_line1: address_validation,
      },
    });

    if (FullName_validation.status && Status_validation.status) {
      this.setState({ sending_data: true });

      const formData = new FormData();
      formData.append("name", this.state.provider_fullname);
      formData.append("phone", (this.state.provider_phone || "").replace(/ /g, ""));
      formData.append("email", (this.state.provider_email || "").trim());
      formData.append("office", localStorage.getItem("selectedOffice"));
      formData.append("specialty", this.state.provider_specialty || "unknown");
      formData.append("address_line1", this.state.address_line1 || "");
      formData.append("birthdate", this.state.birthdate || "");
      formData.append("city", this.state.city || "");
      formData.append("status", this.state.provider_status);
      formData.append("license_number", this.state.license_number != null ? String(this.state.license_number) : "");
      formData.append("unique_provider_number", this.state.unique_provider_number != null ? String(this.state.unique_provider_number) : "");
      if (this.state.providerImage) {
        formData.append("image", this.state.providerImage);
      }

      const response = await controller.updateProvider(id, formData);
      const saveHttp = httpStatusFromControllerResponse(response);
      if (saveHttp != null && saveHttp > 250) {
        this.openNotification("bottom", JSON.stringify(response.detail || response), "Error");
        this.setState({
          formError: {
            ...this.state.formError,
            FullName: { status: response.name ? false : true, massage: response.name ? response.name : "" },
            Status: { status: response.status ? false : true, massage: response.status ? response.status : "" },
            Email: { status: response.email ? false : true, massage: response.email ? response.email : "" },
            Type: { status: response.appointment_type ? false : true, massage: response.appointment_type ? response.appointment_type : "" },
            Specialty: { status: response.specialty ? false : true, massage: response.specialty ? response.specialty : "" },
            Image: { status: response.image ? false : true, massage: response.image ? response.image : "" },
            Phone: { status: response.phone ? false : true, massage: response.phone ? response.phone : "" },
            city: { status: response.city ? false : true, massage: response.city ? response.city : "" },
            birthdate: { status: response.birthdate ? false : true, massage: response.birthdate ? response.birthdate : "" },
            address_line1: { status: response.address_line1 ? false : true, massage: response.address_line1 ? response.address_line1 : "" },
            license_number: { status: response.license_number ? false : true, massage: response.license_number ? response.license_number : "" },
            unique_provider_number: {
              status: response.unique_provider_number ? false : true,
              massage: response.unique_provider_number ? response.unique_provider_number : "",
            },
          },
        });
      } else {
        try {
          await syncAppointmentTypesForProvider(Number(id), this.state.appt_types_id || []);
        } catch (syncErr) {
          console.warn(syncErr);
        }
        this.openNotification("bottom", "Provider updated successfully.", "Successful");
        this.props.dispatch(push("/office/providers"));
      }
    }

    this.setState({ sending_data: false });
  };

  handleUpload = (acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      this.setState({ providerImage: acceptedFiles[0] });
    }
  };

  existingImageUrl = () => {
    const p = this.state.existingImagePath;
    if (!p) return "";
    if (typeof p === "string" && p.startsWith("http")) return p;
    return config.apiGateway.URL + p;
  };

  render() {
    const { profileSummary } = this.props;
    const { formError, providerImage, loading, loadError } = this.state;

    if (loadError) {
      return (
        <DashboardLayout logo={profileSummary && profileSummary.logo ? profileSummary.logo : ""} footerLogo={this.state.serverLogo} breadCrumb={"Edit provider"}>
          <div style={{ margin: 32 }}>{loadError}</div>
        </DashboardLayout>
      );
    }

    return (
      <DashboardLayout
        logo={profileSummary && profileSummary.logo ? profileSummary.logo : ""}
        footerLogo={this.state.serverLogo}
        breadCrumb={"Edit provider"}
      >
        <Spin spinning={loading}>
          <Title level={3} className="title-provider">
            Edit provider
          </Title>
          <Card className="card-provider">
            <Row gutter={[16, 16]} style={{ marginBottom: 40 }}>
              <Col xs={24} sm={12} md={8}>
                <label className="form-label">Provider Full-Name</label>
                <Input
                  className={this.state.formError && this.state.formError.FullName && this.state.formError.FullName.status ? "" : "inputs-error"}
                  type="text"
                  name="provider_fullname"
                  placeholder="Enter Provider Full Name"
                  value={this.state.provider_fullname}
                  onChange={this.handleChange}
                  style={{ height: 42, borderRadius: "8px", border: "1px solid #6B43B5", width: "95%" }}
                />
                {formError && !formError.FullName.status && <div className="error-text">{formError.FullName.massage}</div>}
              </Col>
              <Col xs={24} sm={12} md={8}>
                <label className="form-label">Provider Phone</label>
                <Input
                  className={formError.Phone && formError.Phone.status ? "" : "inputs-error"}
                  type="text"
                  name="provider_phone"
                  placeholder="Enter Provider Phone"
                  value={this.state.provider_phone}
                  onChange={this.handleChange}
                  style={{ height: 42, borderRadius: "8px", border: "1px solid #6B43B5", width: "95%" }}
                />
                {formError && !formError.Phone.status && <div className="error-text">{formError.Phone.massage}</div>}
              </Col>
              <Col xs={24} sm={12} md={8}>
                <label className="form-label">Provider Email</label>
                <Input
                  className={formError.Email && formError.Email.status ? "" : "inputs-error"}
                  type="email"
                  name="provider_email"
                  placeholder="Enter Provider Email"
                  value={this.state.provider_email}
                  onChange={this.handleChange}
                  style={{ height: 42, borderRadius: "8px", border: "1px solid #6B43B5", width: "95%" }}
                />
                {formError && !formError.Email.status && <div className="error-text">{formError.Email.massage}</div>}
              </Col>
            </Row>
            <Row gutter={[16, 16]} style={{ marginBottom: 40 }}>
              <Col xs={24} sm={12} md={8}>
                <label className="form-label">License Number</label>
                <Input
                  className={formError.license_number && formError.license_number.status ? "" : "inputs-error"}
                  type="text"
                  name="license_number"
                  placeholder="License number"
                  value={this.state.license_number}
                  onChange={this.handleChange}
                  style={{ height: 42, borderRadius: "8px", border: "1px solid #6B43B5", width: "95%" }}
                />
                {formError && formError.license_number && !formError.license_number.status && (
                  <div className="error-text">{formError.license_number.massage}</div>
                )}
              </Col>
              <Col xs={24} sm={12} md={8}>
                <label className="form-label">Unique Provider Number</label>
                <Input
                  className={formError.unique_provider_number && formError.unique_provider_number.status ? "" : "inputs-error"}
                  type="text"
                  name="unique_provider_number"
                  placeholder="Unique provider number"
                  value={this.state.unique_provider_number}
                  onChange={this.handleChange}
                  style={{ height: 42, borderRadius: "8px", border: "1px solid #6B43B5", width: "95%" }}
                />
                {formError && formError.unique_provider_number && !formError.unique_provider_number.status && (
                  <div className="error-text">{formError.unique_provider_number.massage}</div>
                )}
              </Col>
            </Row>
            <Row gutter={[16, 16]} style={{ marginBottom: 40 }}>
              <Col xs={24} sm={12} md={8}>
                <label className="form-label">Provider Birth Date</label>
                <DatePicker
                  className={formError.birthdate && formError.birthdate.status ? "w100p" : "inputs-error w100p"}
                  name="birthdate"
                  placeholder="Choose date"
                  suffixIcon={<img src={calendar} alt="" />}
                  onChange={this.handleBirthDateChange}
                  value={this.state.patient_birth_Date}
                  style={{ height: 42, borderRadius: "8px", border: "1px solid #6B43B5", width: "95%" }}
                />
                {formError && !formError.birthdate.status && <div className="error-text">{formError.birthdate.massage}</div>}
              </Col>
              <Col xs={24} sm={12} md={8}>
                <label className="form-label">City</label>
                <Input
                  className={formError.city && formError.city.status ? "" : "inputs-error"}
                  type="text"
                  name="city"
                  placeholder="Select Provider City"
                  value={this.state.city}
                  onChange={this.handleChange}
                  style={{ height: 42, borderRadius: "8px", border: "1px solid #6B43B5", width: "95%" }}
                />
                {formError && !formError.city.status && <div className="error-text">{formError.city.massage}</div>}
              </Col>
              <Col xs={24} sm={12} md={8}>
                <label className="form-label">Status</label>
                <Select
                  className={
                    formError.Status && formError.Status.status ? "w100p" : "w100p inputs-error"
                  }
                  placeholder="Status"
                  value={this.state.provider_status || undefined}
                  onChange={(v) => this.setState({ provider_status: v })}
                  style={{ height: 42, borderRadius: "8px", border: "1px solid #6B43B5", width: "95%" }}
                >
                  <Option value="Active">Active</Option>
                  <Option value="Inactive">Inactive</Option>
                </Select>
                {formError && formError.Status && !formError.Status.status && (
                  <div className="error-text">{formError.Status.massage}</div>
                )}
              </Col>
            </Row>
            <Row gutter={[16, 16]} style={{ marginBottom: 40 }}>
              <Col xs={24} sm={12} md={8}>
                <label className="form-label">Provider Address</label>
                <Input
                  className={formError.address_line1 && formError.address_line1.status ? "" : "inputs-error"}
                  type="text"
                  name="address_line1"
                  placeholder="Enter Provider Address"
                  value={this.state.address_line1}
                  onChange={this.handleChange}
                  style={{ height: 42, borderRadius: "8px", border: "1px solid #6B43B5", width: "95%" }}
                />
                {formError && !formError.address_line1.status && <div className="error-text">{formError.address_line1.massage}</div>}
              </Col>
            </Row>
            <Row gutter={[16, 16]} style={{ marginBottom: 20 }}>
              <Col xs={24} sm={12} md={8}>
                <label className="form-label">Appointment Type</label>
                {this.state.office_services.length > 0 ? (
                  <Select
                    className={formError.Type && formError.Type.status ? "inputs w100p" : "inputs-error w100p"}
                    mode="multiple"
                    placeholder="Select Appointment"
                    value={this.state.appt_types}
                    onChange={this.handleChangeAppointmentType}
                    suffixIcon={<img src={arrow} alt="" />}
                    style={{ height: 42, borderRadius: "7px", border: "1px solid #6B43B5", width: "95%" }}
                  >
                    {this.state.office_services.map((service) => (
                      <Option key={service.id} value={service.service}>
                        {service.service}
                      </Option>
                    ))}
                  </Select>
                ) : (
                  <p className="cr">
                    *There isn&apos;t any appointment type for your office,
                    <br />
                    Please create some appointment type.
                  </p>
                )}
                {formError && !formError.Type.status && <div className="error-text">{formError.Type.massage}</div>}
              </Col>
              <Col xs={24} sm={12} md={8}>
                <label className="form-label">Operatories</label>
                <Select className="w100p" mode="multiple" placeholder="Select Operatories" disabled suffixIcon={<img src={arrow} alt="" />} style={{ height: 42, borderRadius: "7px", border: "1px solid #6B43B5", width: "95%" }}>
                  {this.state.operatories}
                </Select>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <label className="form-label">Provider Specialty</label>
                <Radio.Group
                  className="radio-provider"
                  name="provider_specialty"
                  value={this.state.provider_specialty}
                  onChange={(e) => this.setState({ provider_specialty: e.target.value })}
                >
                  <Radio className="mr-radio" value="Dental Hygienist">
                    Dental Hygienist
                  </Radio>
                  <Radio value="General Dentist">General Dentist</Radio>
                </Radio.Group>
                {formError && !formError.Specialty.status && <div className="error-text">{formError.Specialty.massage}</div>}
              </Col>
            </Row>
            <div style={{ marginBottom: "30px" }}>
              <label className="form-label">Provider Image</label>
              {formError.Image && !formError.Image.status && <div className="error-text">{formError.Image.massage}</div>}
              <Dropzone multiple={false} accept={{ "image/*": [".jpg", ".jpeg", ".png"] }} onDrop={this.handleUpload}>
                {({ getRootProps, getInputProps }) => (
                  <section className="container1">
                    <div {...getRootProps({ className: "dropzone" })}>
                      <input {...getInputProps()} />
                      <label
                        className="formLabel"
                        style={{
                          color: "gray",
                          display: "flex",
                          height: "90px",
                          alignItems: "center",
                          justifyContent: "center",
                          border: "1px dashed #B7B7B7",
                          borderWidth: 2,
                          borderRadius: "8px",
                          cursor: "pointer",
                          maxWidth: "370px",
                        }}
                      >
                        <div style={{ color: "#B7B7B7" }}>
                          Drag and drop or <Button type="link" style={{ margin: 0, fontSize: 12 }}>Browse</Button> to replace image
                        </div>
                      </label>
                    </div>
                  </section>
                )}
              </Dropzone>
              <div className="tac">
                {providerImage ? (
                  <img width="150" height="100" alt="New" src={URL.createObjectURL(providerImage)} />
                ) : this.existingImageUrl() ? (
                  <img width="150" height="100" alt="Current" src={this.existingImageUrl()} />
                ) : null}
              </div>
            </div>
          </Card>
          <div className="box-btn">
            <Button onClick={() => this.props.dispatch(push("/office/providers"))} style={{ marginRight: 16 }}>
              Cancel
            </Button>
            <Button onClick={this.handleSubmit} className="btn-provider" type="button" disabled={this.state.sending_data}>
              {this.state.sending_data ? "Saving…" : "Save changes"}
            </Button>
          </div>
        </Spin>
      </DashboardLayout>
    );
  }
}

function mapStateToProps(state) {
  const { creating, error } = state.paymentRequest;
  const { profileSummary } = state.dashboard;
  return { creating, error, profileSummary };
}

export default connect(mapStateToProps)(withRouter(EditProvider));
